import { supabase } from '@/integrations/supabase/client';
import type { Database } from '@/integrations/supabase/types';

export type Configuracoes = Database['public']['Tables']['configuracoes']['Row'];
export type ConfiguracoesUpdate = Database['public']['Tables']['configuracoes']['Update'];

/**
 * Fetches the configurações row for the current org.
 * Org scoping via RLS on `configuracoes` — one row per org.
 * Throws if no row exists (`.single()` behavior).
 */
export async function getConfiguracoes(): Promise<Configuracoes> {
  const { data, error } = await supabase
    .from('configuracoes')
    .select('*')
    .limit(1)
    .single();

  if (error) throw error;
  return data;
}

/**
 * Updates the configurações row. Legacy 2-step flow preserved:
 * 1. Fetch the row id (RLS-scoped to the current org)
 * 2. Update by id, returning the full updated row
 *
 * Injects `atualizado_em = now()` client-side.
 * Throws `Configurações não encontradas` if step 1 returns no row.
 */
export async function atualizarConfiguracoes(dados: ConfiguracoesUpdate): Promise<Configuracoes> {
  const { data: existing } = await supabase
    .from('configuracoes')
    .select('id')
    .limit(1)
    .single();

  if (!existing) throw new Error('Configurações não encontradas');

  const { data, error } = await supabase
    .from('configuracoes')
    .update({ ...dados, atualizado_em: new Date().toISOString() })
    .eq('id', existing.id)
    .select()
    .single();

  if (error) throw error;
  return data;
}
